<script setup>
import { computed } from 'vue';
import { getDirectionBackground, randomColor } from '../../helpers';
import Sheet from './../Sheet.vue';
import PriceTargetsRange from './PriceTargetsRange.vue';
import { getTopBottomCoordinates, lastMarketAnalysis, insertStateClasses } from './utils';

const props = defineProps({
    priceTarget: {
        type: Object,
        required: true
    },
    priceTargetsStates: {
        type: Object,
        required: true
    }
});

const stateTitle = computed(() => {
    const state = Object.keys(props.priceTargetsStates).find((state) => state === props.priceTarget.state);

    return state ? props.priceTargetsStates[state] : props.priceTarget.state;
});
</script>

<template>
    <Sheet flat compact class="p-4 flex-1 h-full min-w-[240px]">
        <router-link :to="lastMarketAnalysis(priceTarget.recent_contentstream)">
            <div class="flex flex-col gap-4 items-center">
                <div class="flex flex-row gap-4">
                    <div class="flex items-center">
                        <div v-if="priceTarget.market_symbol.logo" class="flex-shrink-0">
                            <img class="w-10 h-10 rounded-xl object-contain" :src="priceTarget.market_symbol.logo" />
                        </div>
                        <div v-else :style="{ backgroundColor: randomColor() }" class="flex items-center justify-center rounded-xl w-10 h-10">
                            <i class="fi fi-rr-apartment text-white text-lg"></i>
                        </div>
                    </div>

                    <div class="gap-2">
                        <span class="text-xs font-semibold block truncate max-w-[140px]">
                            {{ priceTarget.market_symbol.name }}
                        </span>
                        <div :class="getDirectionBackground(priceTarget?.direction)" class="uppercase px-3 rounded-lg text-xxs font-semibold w-fit">
                            {{ priceTarget?.direction }}
                        </div>
                    </div>
                </div>
                <div class="border border-b border-gray-200 w-full"></div>
                <div>
                    <PriceTargetsRange
                        :level="priceTarget.level"
                        :direction="priceTarget.direction"
                        :last-price="priceTarget.market_symbol.last_price"
                        :min="getTopBottomCoordinates('bottom', priceTarget.min, priceTarget.max)"
                        :max="getTopBottomCoordinates('top', priceTarget.min, priceTarget.max)"
                        class="my-2"
                    />
                </div>
                <span :class="insertStateClasses(priceTarget.state)" class="px-3 py-1 rounded-full text-xxs font-semibold w-full text-center">
                    {{ $translate(stateTitle) }}
                </span>
            </div>
        </router-link>
    </Sheet>
</template>
